import React, {useCallback, useRef} from 'react';
import PropTypes from 'prop-types';
import {ClickToReveal} from '@trailhead-emu/design-system';
import track from 'lib/tracking/track';

// Matches the click_to_reveal_* schema examples in trailhead-messaging.
const PAGE_LOCATION = 'click-to-reveal';

export default function ClickToRevealHost({items, variant, ariaLabel}) {
  const startedRef = useRef(false);

  // TDS2 fires onExpandedChange(id, true) on the first reveal and on every
  // reopen, so each open counts as one click_to_reveal_expanded.
  const handleExpandedChange = useCallback((id, expanded) => {
    if (!expanded) {
      return;
    }

    if (!startedRef.current) {
      startedRef.current = true;
      track('click_to_reveal_started', {
        pageLocation: PAGE_LOCATION,
        item_count: items.length,
        variant
      });
    }

    track('click_to_reveal_expanded', {
      pageLocation: PAGE_LOCATION,
      item_id: id,
      item_index: items.findIndex((item) => item.id === id)
    });
  }, [items, variant]);

  return (
    <ClickToReveal
      items={items}
      variant={variant}
      ariaLabel={ariaLabel}
      onExpandedChange={handleExpandedChange}
    />
  );
}

ClickToRevealHost.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      trigger: PropTypes.node,
      content: PropTypes.node
    })
  ).isRequired,
  variant: PropTypes.oneOf(['sequential']).isRequired,
  ariaLabel: PropTypes.string.isRequired
};
